/**
 * Interval for pooling payment state
 */

export const PAYMENT_STATE_FETCH_INTERVAL = 3000;
